import React from 'react';
import CustomerAddEditModal from './customermasters-add-edit';

import { MODAL_TYPES } from 'Feature/components/app-modals';

const { CUSTOMERS_ADD_EDIT } = MODAL_TYPES;

const CustomerModals = () => {
  return (
    <>
      <CustomerAddEditModal modalId={CUSTOMERS_ADD_EDIT} />

    </>
  );
};

export default CustomerModals;
